import type { Labelled } from '../../vocab/VocabularyProvider';

/**
 * The leading glyph on a backlog row (screenshots 1–4: a bookmark for a story, a red target for a
 * bug). Our own SVG, drawn here — ⛔ `type_def.icon` is a name from the database and must never be
 * interpolated into markup.
 */
const SHAPES: Record<string, { fill: string; path: string }> = {
  story: { fill: '#4bade8', path: 'M4 2h8a1 1 0 0 1 1 1v11l-5-3-5 3V3a1 1 0 0 1 1-1z' },
  bug: { fill: '#e2483d', path: 'M8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2zm0 3a3 3 0 1 1 0 6 3 3 0 0 1 0-6z' },
  change_request: { fill: '#8270db', path: 'M8 1l7 7-7 7-7-7 7-7zm0 3.5L4.5 8 8 11.5 11.5 8 8 4.5z' },
  support: { fill: '#e56910', path: 'M2 3h12v8H9l-3 3v-3H2V3z' },
  task: { fill: '#4bade8', path: 'M3 2h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm4.2 9.4l4.6-4.6-1.1-1.1-3.5 3.5-1.6-1.6L4.5 8.7l2.7 2.7z' },
  sub_task: { fill: '#2a8a5f', path: 'M3 2h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm1.5 5.2h7v1.6h-7V7.2z' },
};

const UNKNOWN = { fill: '#8993a4', path: 'M8 1.5A6.5 6.5 0 1 0 8 14.5 6.5 6.5 0 0 0 8 1.5z' };

export function TypeIcon({ type, size = 15 }: { type: Labelled | null; size?: number }) {
  const shape = (type && SHAPES[type.code]) ?? UNKNOWN;
  const label = type ? type.label : 'Unknown type';
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      role="img"
      aria-label={label}
      className="shrink-0"
    >
      <title>{label}</title>
      <path d={shape.path} fill={shape.fill} />
    </svg>
  );
}
